import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {setHeader} from "../../../../redux/actions/layout/interaction/action";
import {useDispatch} from "react-redux";
import {Form} from "antd";
import DG_Form from "../../../../custom/data-entry/form";
import DG_Button from "../../../../common/button/Button";
import DG_Submit from "../../../../common/button/Submit";
import DG_Cancel from "../../../../common/button/Cancel";
import InputLocation from "./items/InputLocation";
import TextDescription from "./items/description";
import SelectAssignObject from "./items/SelectAssignObject";
import {attendanceGps, DEFAULT_RADIUS, lat_lng} from "./constant/key";
import Radius, {optionTypeGPS} from "./items/InputRadius";
import GeocoderComponent from "./items/GeocoderComponent";
import {
    addSettingLocation,
    loadDetailSettingLocation,
    updateLocation
} from "../../../../api/hrm/timekeeping/time-sheet/location";
import GoogleMapsContainer from "./items/map/GoogleMapsContainer";
import StatusLocation from "./items/StatusLocation";
import {loadTimekeepingCommonConfigApi} from "../../../../api/setting/timekeeping";
import {formatCurrency, unFormatCurrency} from "../../../../format/Money";
import {useTranslation} from "react-i18next";

const AddLocation = props => {
    const {t} = useTranslation()
    const {id} = useParams();
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false)
    const [radius, setRadius] = useState(DEFAULT_RADIUS)
    const [coordinates, setCoordinates] = useState([lat_lng.lat, lat_lng.lng]) // [latitude, longitude]
    const [isLoadingMap, setIsLoadingMap] = useState(id)
    const [defaultStatus, setDefaultStatus] = useState(undefined)
    const [defaultConfigGps, setDefaultConfigGps] = useState(undefined)
    const [dataSource, setDataSource] = useState(undefined)
    const [success, setSuccess] = useState(false)

    useEffect(() => {

        if (!id) {
            form.resetFields()
            dispatch(setHeader(t("tnp.setting.addLocation"), null))
        } else {
            dispatch(setHeader(t("tnp.setting.updateLocation"), null))
        }
    }, [id]);

    useEffect(() => {
        loadTimekeepingCommonConfigApi().then(res => {
            setDefaultConfigGps(res?.attendanceGPS)
            if (id) {
                loadDetailSettingLocation(id).then(res => {
                    setCoordinates([res.latitude, res.longitude])
                    form.setFieldsValue({
                        ...res,
                        radius : formatCurrency(res?.radius)
                    })
                    setRadius(formatCurrency(res?.radius))
                    setDefaultStatus(res?.status)
                    setDataSource(res)
                })
            }
            else {
                setDefaultStatus(res?.attendanceGPS)
            }
        })
    }, [id])

    const onFinish = (value) => {
        setLoading(true)
        value = {
            ...value,
            longitude: coordinates[1],
            latitude: coordinates[0],
            radius: unFormatCurrency(radius),
            type : value?.type || optionTypeGPS(t)[0]?.value
        }


        if(!id){
            addSettingLocation(value).then(r => {
                setLoading(false)
                setSuccess(true)
            }).finally(() => setLoading(false))
        }
        else {
            updateLocation(id,value).then(r => {
                setLoading(false)
                setSuccess(true)
            }).finally(() => setLoading(false))
        }
    }

    return (
        <DG_Form form={form}
                 mode={id ? 'update' : 'add'}
                 labelCol={{
                     span: 8,
                 }}
                 wrapperCol={{
                     span: 16,
                 }}
                 initialValues={{
                     remember: true,
                 }}
                 autoComplete="on"
                 style={{
                     background: "#fff",
                     borderRight: "1px solid #EAECF0",
                     borderLeft: "1px solid #EAECF0",
                     borderTop: "1px solid #EAECF0",
                     height: "100%",
                     overflow: "hidden",
                 }}
                 onFinish={onFinish}
                 success={success}
        >


            <DG_Button title={!id ? t("tnp.setting.addLocation") : t("tnp.setting.updateLocation")}>
                <DG_Submit loading={loading}/>
                <DG_Cancel/>
            </DG_Button>
            <div className={"px-6 py-3 bg-white"} style={{
                overflowY: "auto",
                height: "calc(100vh - 68px - 100px)"
            }}>
                <InputLocation require={true} name={attendanceGps.name} label={t("tnp.setting.nameLabel")}/>
                <TextDescription/>

                <SelectAssignObject
                    form={form}
                    placeholder={t("tnp.setting.objectAssignHolder")}
                />

                <GeocoderComponent setCoordinates={(value) => setCoordinates(value)}
                                   form={form}
                                   setIsLoadingMap={(v) => setIsLoadingMap(v)}
                                   coordinates={coordinates}
                                   name={attendanceGps.address} label={t("tnp.setting.address")}/>


                {/*<MapGLContainerLib coordinates={coordinates}*/}
                {/*                   radius={radius} />*/}

                {isLoadingMap && <GoogleMapsContainer form={form} coordinates={coordinates} radius={radius}
                                                      setRadius={(v) => setRadius(v)}

                />}

                <Radius setRadius={(v) => setRadius(v)} radius={radius} label={t("tnp.setting.boundingType")} form={form}/>
                <StatusLocation
                    title={dataSource?.name || ""}
                    defaultChecked={defaultStatus}
                    defaultConfigGps={defaultConfigGps}
                    name={attendanceGps.status}
                    form={form}
                    label={t("tnp.setting.status")}/>


            </div>
        </DG_Form>
    );
};


export default AddLocation;
